module.exports = __webpack_public_path__ + "resources/img/member_type_business.6ec0c4c8519ce62115fc7c3ef31b8f53.png";